module.exports = __webpack_public_path__ + "img/note-medical.cc0cc3d5.svg";